var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 284,
    viewBox: "0 0 304 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4214 161.798L73.0781 133.084L148.905 78.8926L224.732 133.084L198.984 161.798H98.4214Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4214 161.798L73.0781 133.084L148.905 78.8926L224.732 133.084L198.984 161.798H98.4214Z",
    fill: "#514ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.083 136.724H73.0781V201.229H221.083V136.724Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.083 136.724H73.0781V201.229H221.083V136.724Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.732 224.28H73.0781V133.084L148.905 178.784L224.732 133.084V224.28Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.387 102.514L189.303 90.2144L146.698 145.63L123.035 127.534L110.702 143.575L142.405 167.783L150.535 173.86L205.387 102.514Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7173 112.638L73.1144 112.931L73.1837 112.808L73.1308 112.825L73.205 112.77L81.3203 98.3667L85.4687 101.894L89.0275 105.181L88.0057 105.678L89.1545 107.699L73.7173 112.638Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0578 102.271L88.3106 105.279L73.5669 112.59L81.413 102.56L85.0578 102.271Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.0578 102.271L88.3106 105.279L73.5669 112.59L81.413 102.56L85.0578 102.271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2636 99.0447L73.5669 112.59L85.0578 102.271L81.2636 99.0447Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4056 107.608L73.5828 112.492L85.9736 103.267L88.4056 107.608Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.357 86.7241L209.109 92.3393L232.92 96.2061L217.584 85.5552L212.357 86.7241Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M212.357 86.7241L209.109 92.3393L232.92 96.2061L217.584 85.5552L212.357 86.7241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.267 80.5696L232.92 96.2062L212.357 86.7242L216.267 80.5696Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.988 95.6398L232.855 96.0755L211.507 88.5129L209.988 95.6398Z",
    fill: "#037DBA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.515 36.3071C152.374 29.9424 139.454 32.5089 128.589 37.293C94.4591 52.3243 71.0457 86.2095 52.9615 121.481C46.4128 134.248 40.279 147.674 38.4604 162.638C34.7453 193.101 51.5916 227.301 77.4607 241.87C86.2638 246.826 95.7686 249.634 105.238 251.722C122.081 255.454 139.379 257.072 155.623 253.421C167.206 250.808 177.991 245.58 188.27 239.594C216.997 222.871 242.718 199.659 260.394 169.541C268.137 156.304 274.446 141.103 273.615 124.594C272.785 108.085 263.011 90.3382 248.487 85.6741C242.48 83.7447 236.28 84.1416 230.238 84.5975C221.341 85.2672 212.327 86.0153 203.362 84.0523C194.106 82.0272 181.847 76.0577 179.501 64.9732C176.978 53.0793 174.645 42.6756 163.515 36.3071Z",
    fill: "#039BE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 147.081,
    y1: 201.229,
    x2: 147.081,
    y2: 136.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55135,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 85.1451,
    y1: 112.39,
    x2: 76.0094,
    y2: 104.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.0781,
    y: 78.8926,
    width: 159.842,
    height: 145.388,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCheck);
export default __webpack_public_path__ + "static/media/mail-check.13e333ab.svg";
export { ForwardRef as ReactComponent };